<script setup>
  import CurrentAdjusterPayComponent from "@/Components/AdjusterPay/CurrentAdjusterPayComponent.vue";
  import {Permissions} from "@/Utils/Permissions";
</script>

<template>
  <v-container fluid style="min-height: 100vh;">
    <v-row v-if="Permissions.checkPermissions(['financials.current-adjuster-pay'])">
      <v-col cols="12">
        <CurrentAdjusterPayComponent/>
      </v-col>
    </v-row>
  </v-container>
</template>

<style scoped>

</style>